import { Button, Spinner } from 'reactstrap';

interface Props {
  isLoadingPdf: boolean;
  isLoadingExcel: boolean;
  handlePdf: () => void;
  handleExcel: () => void;
  disabled: boolean;
}

export const SuspectedTableActions = ({
  isLoadingPdf,
  isLoadingExcel,
  handlePdf,
  handleExcel,
  disabled,
}: Props) => {
  const disableActions = disabled || isLoadingPdf || isLoadingExcel;

  return (
    <div className="d-flex flex-wrap justify-content-end gap-2">
      <Button
        onClick={handlePdf}
        color="primary"
        type="button"
        className="btn btn-light waves-effect waves-light"
        disabled={disableActions}
      >
        {isLoadingPdf ? (
          <Spinner size="sm">Carregando...</Spinner>
        ) : (
          <>
            PDF
            <i className="las la-file-pdf mx-2"></i>
          </>
        )}
      </Button>
      <Button
        onClick={handleExcel}
        color="primary"
        type="button"
        className="btn btn-light waves-effect waves-light"
        disabled={disableActions}
      >
        {isLoadingExcel ? (
          <Spinner size="sm">Carregando...</Spinner>
        ) : (
          <>
            Excel
            <i className="ms-2 ri-file-excel-2-line"></i>
          </>
        )}
      </Button>
    </div>
  );
};
